import type {
  ICustomZendeskField,
  ICustomZendeskDropdownField,
} from '../types';
import {
  ACCOUNT_NAME,
  BILLING_DISPUTE_REASON,
  BLOCKER_TYPE, NAME,
  REQUEST_TYPE,
  WEBSITE_URL,
} from './ZD_FIELD_IDS';
import { MFA_SUPPORT_ZENDESK_ID } from '../fields/mfa_support_zendesk_fields';

export const {
  MFA_REASON,
} = MFA_SUPPORT_ZENDESK_ID;

// Customer Name field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/1260822048450
export const name: ICustomZendeskField = {
  id: NAME,
};

// Customer Account Name field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/1900001824264
export const accountName: ICustomZendeskField = {
  id: ACCOUNT_NAME,
};

// Customer Website URL field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/1260822291809
export const websiteUrl: ICustomZendeskField = {
  id: WEBSITE_URL,
};

// Request type field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/1260819957729
export const requestType = {
  id: REQUEST_TYPE,
  fieldValues: {
    accountAccess: {
      value: 'Account access',
      tag: 'recovery_account_access',
    },
  },
};

export const ZD_REQUEST_TYPE_ID_VALUE_TAG = {
  id: requestType.id,
  value: requestType.fieldValues.accountAccess.value,
  tag: requestType.fieldValues.accountAccess.tag,
};

// Blocker type field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/1260819959789
export const blockerType = {
  id: BLOCKER_TYPE,
  fieldValues: {
    accountDisabled: {
      value: 'Account disabled',
      tag: 'account_disabled',
    },
    forgotPassword: {
      value: 'Forgot password',
      tag: 'forgot_password',
    },
    invoiceInquiry: {
      value: 'Invoice inquiry',
      tag: 'invoice_inquiry',
    },
    multifactorAuthentication: {
      value: 'Multi-factor authentication support',
      tag: 'multifactor_authentication_support',
    },
    newDeviceCode: {
      value: 'Setting up a new device',
      tag: 'setting_up_new_device',
    },
    updateAccountOwner: {
      value: 'Update account owner',
      tag: 'new_account_owner',
    },
  },
};

// Billing Dispute Reason field
// https://klaviyo.zendesk.com/admin/objects-rules/tickets/ticket-fields/12414308342043
export const billingDisputeReason = {
  id: BILLING_DISPUTE_REASON,
  fieldValues: {
    fraudulentCharge: {
      value: 'Fraudulent charge',
      tag: 'recovery_fraudulent_charge',
    },
    invoiceAmount: {
      value: 'Invoice amount',
      tag: 'recovery_invoice_amount',
    },
    postCancelationCharge: {
      value: 'Post-cancelation charge',
      tag: 'recovery_post_cancellation_charge',
    },
    other: {
      value: 'Other',
      tag: 'recovery_other',
    },
  },
};

// Custom Zendesk field definitions with the drop-down field type
export const dropdownFields: { [key: string]: ICustomZendeskDropdownField } = {
  requestType,
  blockerType,
  billingDisputeReason,
};

export const mfaSupportReason: ICustomZendeskField = {
  id: MFA_REASON,
};
